import { chart } from "@/api/chart";
import { State } from "../state";
import { commitDrawEChart } from "./mutations";
import { chartState } from "./state";
import { ActionContext } from "vuex";
type chartContext = ActionContext<chartState, State>;

export const actions = {
  async drawEChart(context: any) {
    try {
      const response = (
        await Promise.all([
          chart.echartsOptions("1"),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];

      commitDrawEChart(context, response);
    } catch (error) {
      // await dispatchCheckApiError(context, error);
    }
  },
};

import { getStoreAccessors } from "typesafe-vuex";
const { dispatch } = getStoreAccessors<chartState | any, State>("");

export const dispatchDrawEChart = dispatch(actions.drawEChart);
